import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    requestStart(state) {
      state.loading = true;
      state.error = null;
    },
    requestSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    requestFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { requestStart, requestSuccess, requestFailure } =
  settingsSlice.actions;

export default settingsSlice.reducer;

/**
 * Register a new user.
 * @param {Object} formValues - The form values for registration.
 * @param {Function} navigate - The navigation function.
 */

export const Getsettings = (headers) => async (dispatch) => {
  try {
    dispatch(requestStart());

    await axios
      .get("/private/settings")
      .then((respo) => {
        dispatch(requestSuccess(respo?.data));
      })
      .catch((err) => {
        toast.error(err);
        dispatch(requestFailure(err));
      });
  } catch (error) {
    dispatch(requestFailure(error?.response?.data || "Something went wrong!"));
    toast.error(error?.response?.data || "Something went wrong!");
  }
};
export const UpdateBaseSettings = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const res = await axios.put("/private/settings", data);
    toast.success("Settings updated successfully!");
  } catch (error) {
    dispatch(requestFailure(error?.response?.data || "Something went wrong!"));
    toast.error(error?.response?.data || "Something went wrong!");
  }
};
